<div *ngIf="amountRemainingToMinimumOrderValue > 0" [@minimumOrderValueAnimation] class="min-order-value">
  {{ "GROCERY_VENDOR_DETAILS_PAGE.REMAINING_TO_MOV" | translate : { amount: (amountRemainingToMinimumOrderValue | localCurrency) } }}
</div>
<div class="total">
  <div class="start">
    <div class="name">{{ vendorName }}</div>
  </div>

  <div class="end">
    <span *ngIf="cartItemsPrice" class="price">{{ cartItemsPrice | localCurrency }}</span>
    <span *ngIf="cartPriceBeforeDiscount && cartPriceBeforeDiscount !== cartItemsPrice" class="retail-price">
      {{ cartPriceBeforeDiscount | localCurrency }}
    </span>
  </div>
</div>
